import axiosInstance from './axiosCreator';

export const getIncorrectVignetteResponses = async (studySessionId: string) => {
  const response = await axiosInstance.get(
    `/vignetteResponses/incorrect/${studySessionId}`
  );
  return response.data;
};
